import { Grid, Typography } from "@mui/material";
import UserManagementDesc from "./UserManagementDesc";

interface UserManagementNoteProps {
  numberOfAdmins?: number;
  numberOfStandardUsers?: number;
  numberOfViewers?: number;
}

export default function UserManagementNote(props: Readonly<UserManagementNoteProps>) {
  return (
    
      <Grid container spacing={2}>
        <Grid item xs={12} sx={{ ml: 0, mt: 2 }} >
            <UserManagementDesc />
        </Grid>
        <Grid item xs={12} sx={{ ml: 2 }}>
          <Typography style={{ whiteSpace: "pre-line" }}>
            Your current plan allows:
            <br />
            • {props.numberOfAdmins} Admin users
            <br />
            • {props.numberOfStandardUsers} Standard users
            <br />
            • {props.numberOfViewers} Viewer users
            <br />
            <br />
            Contact Arcadis support to increase these limits.
          </Typography>
        </Grid>
        
        
      </Grid>
    
  );
}
